import "core-js/modules/es6.regexp.flags.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-inline-block test-5"
  }, [_vm._l(_vm.flags, function (flag, index) {
    return _c('div', {
      key: "".concat(flag.name, "-").concat(index),
      staticClass: "d-inline-block test-6"
    }, [!_vm.isRse(flag) ? _c('p', {
      staticClass: "flag-name",
      class: _vm.isOnSales ? 'sales-price mr-1' : 'mr-2',
      style: {
        color: _vm.isOnSales ? '#e16e5f' : flag.color
      }
    }, [_vm._v("\n      " + _vm._s(flag.name) + "\n    ")]) : _c('MdmIcon', {
      staticClass: "logoRse",
      attrs: {
        "name": "RSE-logo",
        "width": "167",
        "height": "61",
        "title": flag.name
      }
    })], 1);
  }), _vm._v(" "), _vm.deliverySaleLabel ? _c('p', {
    staticClass: "flag-name"
  }, [_vm._v("\n    " + _vm._s(_vm.deliverySaleLabel) + "\n  ")]) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };